import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';
import { IServiceProviderSearchParameters } from 'src/app/Models/IServiceProviderSearchParameters';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { IStudentByProviderSearchParameters } from '../../../Models/IStudentByProviderSearchParameters';

@Component({
  selector: 'app-_401_MissingStudentIdReport',
  templateUrl: './_401_MissingStudentIdReport.component.html',
  styleUrls: ['./_401_MissingStudentIdReport.component.css']
})
export class _401_MissingStudentIdReportComponent implements OnInit {
  _baseUrl: string;
  _myGlobals: Globals;
  isReportButtonDisabled: boolean = true;
  isPAUSelected: boolean = false;
  reportFileName: string = "Aeries_MissingStudentId";
  schoolStartDate: Date;

  date: Date; //datepicker
  selectedReport: SelectItem;//dropdown
  _reportId: string = null;//dropdown
  radioBtnSelection: string = 'English';  //radiobutton
  public showSpinner: boolean = false;

  //lookups
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService,
    @Inject('BASE_URL') baseUrl: string, reportService: ReportService) {  
    this._lookupService = lookupService;
    this._baseUrl = baseUrl;
    this._reportService = reportService;
    this.date = new Date();
  }

  ngOnInit() {
    let today = new Date();
    let lastYear: number = today.getFullYear() - 1;
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.isReportButtonDisabled = false; //allow initially

    if (today.getMonth() >= 6) {
      this.schoolStartDate = new Date(7 + '/' + 1 + '/' + today.getFullYear());
    } else {
      this.schoolStartDate = new Date(7 + '/' + 1 + '/' + lastYear);
    }

    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    
  }
  
  checkRadioButton(id): void {
    this.radioBtnSelection = id;
  }

  getSelectedDateData() {
    this.LoadLookupValues();
  }

  viewReport() {
    let reportParamArray: IReportParameter[] = [];

    reportParamArray.push(
      { parameterName: 'StartingDate', parameterValue: this.schoolStartDate.toISOString().slice(0, 10) }, 
      { parameterName: 'EndingDate', parameterValue: this.date.toISOString().slice(0, 10) },
      { parameterName: 'AsOfDate', parameterValue: this.date.toISOString().slice(0, 10) },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' }
    );

    let now = new Date();
    let localReportFileName = '401-MissingStudentId_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = this.reportFileName;  
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
